import { Button, cn, TopPharmacyBadge } from "@au-schein-de/au-ui-library";
import type { PharmacyPickerGroupShortcut } from "~/features/products/pharmacy-picker/pharmacy-picker.types";

export function PharmacyPickerGroupButton({
	group,
	isActive = false,
	onClick,
}: {
	group: PharmacyPickerGroupShortcut;
	isActive?: boolean;
	onClick: () => void;
}) {
	return (
		<Button
			type="button"
			variant="ghost"
			size={null}
			className={cn(
				"h-12 w-full justify-start gap-2 rounded-xl bg-white px-4 text-body-bold outline-ansay-main hover:bg-gray-100",
				isActive ? "border-2 border-ansay-main" : "border-2 border-gray-200",
			)}
			onClick={onClick}
			aria-pressed={isActive}
			data-testid={`pharmacy-picker-group-${group.id}`}
		>
			{group.id === "top" && <TopPharmacyBadge />}
			<span className={isActive ? "text-ansay-dark" : "text-gray-700"}>
				{group.label} ({group.count})
			</span>
		</Button>
	);
}
